import { Icon, IconName, Typography } from '../../../base-components';
import { ICell, SortDirection } from '../../table.interfaces';
import { StyledIconButton, StyledTableHeaderCell } from './HeaderCell.styles';
import { SortDirections } from '../../table.consts';
import { isValidString } from '../../../../common';
import { useFormContext } from 'react-hook-form';
import {
    ITableForm,
    TableFormValues,
} from '../../../../common/interfaces/table.interface';
import { RootState, useAppSelector } from '../../../base-redux';
import { tablesSelectors } from '../../../../actions';

interface IHeaderCellProps {
    cell: ICell;
}

const HeaderCell = (props: IHeaderCellProps) => {
    const { cell } = props;
    const { setValue, watch, getValues } = useFormContext<ITableForm>();
    const tableState = useAppSelector((state: RootState) =>
        tablesSelectors.getTablesState(
            state,
            getValues(TableFormValues.tableId)
        )
    );
    const activeSort = watch(TableFormValues.sort);
    const sortKey = cell.sortKey || cell.id;

    if (!activeSort?.sortKey) {
        setValue(TableFormValues.sort, {
            sortKey: tableState.defaultSortKey,
            sortDirection: SortDirections.desc,
        });
    }

    const getIconName = (): IconName => {
        if (
            activeSort?.sortKey === sortKey &&
            isValidString(activeSort.sortDirection)
        ) {
            return activeSort.sortDirection === SortDirections.asc
                ? 'ExpandLessOutlinedIcon'
                : 'ExpandMoreOutlinedIcon';
        }
        return 'UnfoldMoreIcon';
    };

    const changeSortDirection = () => {
        if (activeSort?.sortKey !== sortKey) {
            setValue(TableFormValues.sort, {
                sortKey,
                sortDirection: SortDirections.desc,
            });
        } else {
            let nextDirection: SortDirection;

            if (activeSort.sortDirection === SortDirections.desc) {
                nextDirection = SortDirections.asc;
            } else if (activeSort.sortDirection === SortDirections.asc) {
                nextDirection = '';
            } else {
                nextDirection = SortDirections.desc;
            }
            if (isValidString(nextDirection)) {
                setValue(TableFormValues.sort, {
                    sortKey,
                    sortDirection: nextDirection,
                });
            } else {
                setValue(TableFormValues.sort, {
                    sortKey: tableState.defaultSortKey,
                    sortDirection: SortDirections.desc,
                });
            }
        }
    };

    return (
        <StyledTableHeaderCell>
            <Typography variant="subtitle2" color="textSecondary">
                {cell.headerTitle.toUpperCase()}
            </Typography>
            {cell.isSortable && (
                <StyledIconButton onClick={changeSortDirection}>
                    <Icon size={20} name={getIconName()} color={'action'} />
                </StyledIconButton>
            )}
        </StyledTableHeaderCell>
    );
};

export default HeaderCell;
